import { useEffect } from "react";

import { ErrorNotificationStore } from "@/stores/error-store";

type Props = {
  errorStatusCode: number;
};

function AppErrorDispatcher(props: Props): JSX.Element {
  useEffect(() => {
    ErrorNotificationStore.getInstance().notifyByStatus(
      props.errorStatusCode,
      ""
    );
  }, []);

  return <></>;
}

export default AppErrorDispatcher;
